import Button from 'components/shared/app/Button';
import Config from 'lib/Config';
import TikTokService from 'lib/services/providers/TikTokService';
import { getInnerError, renderLoader } from 'lib/utils/adaya/AdayaUtils';
import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import './style.scss';

// After a user authorizes Tiktok and returns to the site.
// This page prompts them to select an advertiser account to link.

const TikTokCallback = (props) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [accountInfo, setAccountInfo] = useState({});
    const [selectedAdvertiser, setSelectedAdvertiser] = useState(undefined);
    const [accountConnected, setAccountConnected] = useState(false);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        try {
            setLoading(true);
            setError(undefined);

            let ai = await TikTokService.getAccountInfo(window.location.search);
            if (ai && ai.access_token && ai.advertisers) {
                console.log(`Got account info`, ai)
                if (ai.advertisers.length) setAccountInfo(ai);
                else setError('You have no eligible TikTok advertiser accounts.');
            } else {
                setError(`Unexpected response: ${getInnerError(e)}`);
            }
        } catch (e) {
            setError(getInnerError(e));
        }

        setLoading(false);
    };

    const onChangeAccount = (e) => {
        setSelectedAdvertiser(e.target.value);
    };

    const onConnectAccount = async (e) => {
        try {
            setLoading(true);
            setError(undefined);

            let user = await TikTokService.connectTikTokAccount({
                access_token: accountInfo.access_token,
                advertiser_account_id: selectedAdvertiser
            });

            if (user) {
                await props.auth.updateUserLocal(user);
                setAccountConnected(true);
            }
        } catch (e) {
            setError(getInnerError(e));
        }

        setLoading(false);
    };

    const goToAccountButton = () => (
        <>
            <h4 style={{ color: '#fff', margin: '1rem' }}>Thank you for connecting your TikTok account!</h4>
            <Link to="/account">
                <Button round filled color="green">
                    Go To Account
                </Button>
            </Link>
        </>
    );

    const advertiserSelectDropdown = () => (
        <>
            <h5 style={{ color: '#fff', margin: '1rem' }}>Please select the TikTok Advertiser Account:</h5>
            {accountInfo.advertisers ?
                <select onChange={onChangeAccount}>
                    <option>Select..</option>
                    {accountInfo.advertisers.map((a, i) => (
                        <option key={i} value={a.advertiser_id}>{a.advertiser_name}</option>
                    ))}
                </select> :
                <div className="error">There are no advertiser accounts found in the data.</div>
            }
            <br />
            <Button round filled color="green" onClick={onConnectAccount}>
                Select Ads Account
            </Button>
        </>
    );

    const renderError = () => (
        <div className="flex-col-center error">
            <h3>Error</h3>
            <h4 dangerouslySetInnerHTML={{ __html: error }}></h4>
            <p>Please try to connect your TiktTok account again from the Account page.</p>
            <Link to="/account">
                <div className="button color-green filled round">Back to Account</div>
            </Link>
        </div>
    );

    return (
        <div className="tiktok-callback-page">
            <Helmet>
                <title>{Config.SITE_TITLE_PREFIX} - Connecting TikTok Account</title>
            </Helmet>

            {
                error ? renderError() :

                    loading ? renderLoader('Connecting to TikTok...') :

                        accountConnected ? goToAccountButton() : advertiserSelectDropdown()
            }

        </div>
    );

};

export default TikTokCallback;
